import { type Theme } from '@logto/schemas';

import Logo from '@/shared/assets/icons/logto-logo-light.svg?react';

type Props = { readonly className?: string; readonly theme?: Theme };
const LogtoSignature = ({ className, theme }: Props) => {
  return (
    <span
      className={className}
      aria-label="Powered by UnlimitAI"
      data-theme={theme}
      onContextMenu={(event) => {
        event.preventDefault();
      }}
      onDragStart={(event) => {
        event.preventDefault();
      }}
    >
      <Logo style={{ width: 112, height: 24 }} />
    </span>
  );
};

export default LogtoSignature;
